var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { KtsTaskConditionService, TaskCondition } from './task-condition.service';
var KtsTaskConditionComponent = /** @class */ (function (_super) {
    __extends(KtsTaskConditionComponent, _super);
    function KtsTaskConditionComponent(service, baseService, taskCondService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.taskCondService = taskCondService;
        return _this;
    }
    KtsTaskConditionComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (changes.col) {
            this.col = JSOG.parse(JSON.stringify(this.col));
            this.setCols();
            this.getStep();
        }
    };
    KtsTaskConditionComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.projectMIdSubscription = this.taskCondService.observable.subscribe(function (id) { return _this.projectMId = id; });
    };
    KtsTaskConditionComponent.prototype.setCols = function () {
        this.col.items = new TaskCondition(this.col.key, this.msg).cols;
    };
    KtsTaskConditionComponent.prototype.getStep = function () {
        var _this = this;
        this.taskCondService.getType('CONSTRUCTION_STEP').subscribe(function (rec) {
            for (var i = 0; i < rec.length; i++) {
                rec[i].display = 'STEP' + (i + 1) + ': ' + rec[i].display;
            }
            _this.col.items[0].params.options = rec;
            // 表示させるための再セット処理
            var items0 = JSOG.parse(JSON.stringify(_this.col.items[0]));
            _this.col.items.splice(0, 1);
            _this.col.items.splice(0, 0, items0);
            _this.taskCondService.setStep(_this.col.key, rec);
            if (_this.val['$' + _this.col.key + '.task_u.task_m.step']) {
                _this.getTask(_this.val['$' + _this.col.key + '.task_u.task_m.step']);
            }
        });
    };
    KtsTaskConditionComponent.prototype.getTask = function (step) {
        var _this = this;
        if (!this.projectMId) {
            return;
        }
        if (step > 0) {
            this.taskCondService.setBaseUrl('/v1/gen/task-m-api?query={"predicateList":[{"name":"project_m.id","operator":"eq","value":"' + this.projectMId + '"},{"name":"step","operator":"eq","value":"' + step + '"}],"orderByList":[{"name":"disp_order","direction":"asc"}]}');
            this.taskCondService.getRecord().subscribe(function (rec) {
                var options = [];
                for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                    var item = _a[_i];
                    options.push({ code: item.id, display: item.name, data: item });
                }
                _this.col.items[1].params.options = options;
                // 表示させるための再セット処理
                var items1 = JSOG.parse(JSON.stringify(_this.col.items[1]));
                _this.col.items.splice(1, 1);
                _this.col.items.splice(1, 0, items1);
                _this.taskCondService.setTask(_this.col.key, options);
            });
        }
        else {
            this.col.items[1].params.options = [];
            this.taskCondService.setTask(this.col.key, []);
        }
    };
    KtsTaskConditionComponent.prototype.onChangeVal = function (e) {
        if (e.key === '$' + this.col.key + '.task_u.task_m.step') {
            this.getTask(e.val);
            this.onChangeVal({ key: '$' + this.col.key + '.task_u.task_m.id', val: null });
        }
        else if (e.key === '$' + this.col.key + '.task_u.task_m.id') {
            var report = false;
            if (!e.val) {
                this.changeVal.emit({ key: '$' + this.col.key + '.$rangeFrom.task_u.plan_date', val: null });
                this.changeVal.emit({ key: '$' + this.col.key + '.$rangeTo.task_u.plan_date', val: null });
                this.changeVal.emit({ key: '$' + this.col.key + '.task_u.is_complete', val: null });
            }
            else {
                for (var _i = 0, _a = this.col.items[1].params.options; _i < _a.length; _i++) {
                    var option = _a[_i];
                    if (option.code.toString() === e.val.toString() && (option.data['template_type'] === "onsite" /* onsite */ || option.data['template_type'] === "onsite_notime" /* onsite_notime */ || option.data['template_type'] === "construction" /* construction */)) {
                        report = true;
                        break;
                    }
                }
            }
            this.changeVal.emit({ key: '$' + this.col.key + '.$constructionReport', val: report });
        }
        this.changeVal.emit(e);
    };
    KtsTaskConditionComponent.prototype.ngOnDestroy = function () {
        this.projectMIdSubscription.unsubscribe();
    };
    KtsTaskConditionComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-task-condition',
                    template: "<dl [key]=\"key\" [col]=\"col\" columnDir>\n  <dt [key]=\"key\" [col]=\"col\" columnDir>\n    <column-formtitle [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [msg]=\"msg\"></column-formtitle>\n  </dt>\n  <dd [key]=\"key\" [col]=\"col\" columnDir>\n    <ul>\n      <li [key]=\"key\" [col]=\"col.items[0]\" [val]=\"val\" columnDir>\n        <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"col.items[0]\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n      </li>\n      <li *ngIf=\"val[col.items[0].key]\" [key]=\"key\" [col]=\"col.items[1]\" [val]=\"val\" columnDir>\n        <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"col.items[1]\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n      </li>\n      <ng-template [ngIf]=\"val[col.items[1].key]\">\n        <ng-template ngFor let-item [ngForOf]=\"col.items\" let-idx=\"index\">\n          <li *ngIf=\"idx > 1\" [key]=\"key\" [col]=\"item\" [val]=\"val\" columnDir>\n            <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"item\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n          </li>\n        </ng-template>\n      </ng-template>\n    </ul>\n  </dd>\n</dl>\n"
                }] }
    ];
    /** @nocollapse */
    KtsTaskConditionComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: KtsTaskConditionService }
    ]; };
    return KtsTaskConditionComponent;
}(ColumnBaseComponent));
export { KtsTaskConditionComponent };
//# sourceMappingURL=task-condition.component.js.map